import React, { useEffect, useState } from "react";
import PaginationResult from '../../../LobbyContent/SubComponents/PaginationResult';
import { useDispatch, useSelector } from "react-redux";
import { pageNumberInfo, setTotalNoResult } from "../../../../redux/actions";
import { makeAjax, url } from "../../../../helpers/global_helper";
import { withTranslation } from "react-i18next";

function ShioResult(props) {
  const { startDate, endDate, submitTrigger, checkSelected, setSubmitTrigger, pageCall, pageCallFunction } = props;
  const dispatch = useDispatch();
  const country_name = useSelector((state) => state.CommonConfig.country_name);
  const [last10Result, setLast10Result] = useState([]);
  const [result, setResult] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber);
  const [selected, setSelected] = useState('bigsmall');
  const [newStartDate, setNewStartDate] = useState(startDate);
  const [newEndDate, setNewEndDate] = useState(endDate);

  useEffect(() => {
    setResetPage(true);
    setLast10Result([]);
    setNewStartDate('');
    setNewEndDate('');
    fetchData();
  }, [country_name]);

  useEffect(() => {
    setNewStartDate(startDate);
    setNewEndDate(endDate);
  }, [startDate, endDate]);

  const fetchData = (page = 0) => {
    setLast10Result([]);
    const params = {
      gameId: gameId,
      page: pageNumber,
      length: 30,
      startDate: submitTrigger > 0 || page > 0 ? newStartDate : "",
      endDate: submitTrigger > 0 || page > 0 ? newEndDate : ""
    };

    makeAjax(
      url.TOGEL_API.getResultTogelNew,
      params,
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.code === "data_not_found") {
        setLast10Result([]);
        if (page === 0 || submitTrigger > 0) {
          setSubmitTrigger();
        }
        // setSubmitTrigger();
        return;
      }
      setLast10Result(response.data.data);
      if (page === 0 || submitTrigger > 0) {
        setSubmitTrigger();
        pageCallFunction()
      }
      dispatch(setTotalNoResult(response.data.total));
    });
  }

  useEffect(() => {
    // if(submitTrigger === 1) {
    fetchData(1);
    // }
  }, [gameId, pageNumber]);

  useEffect(() => {
    // Ensure it triggers only after an actual submit
    if (submitTrigger === 1) {
      setResetPage(true);
      fetchData();
    }

  }, [submitTrigger]);

  const constantData = [
    [1, 13, 25, 37, 49, 61, 73, 85, 97],
    [2, 14, 26, 38, 50, 62, 74, 86, 98],
    [3, 15, 27, 39, 51, 63, 75, 87, 99],
    [4, 16, 28, 40, 52, 64, 76, 88, 0],
    [5, 17, 29, 41, 53, 65, 77, 89],
    [6, 18, 30, 42, 54, 66, 78, 90],
    [7, 19, 31, 43, 55, 67, 79, 91],
    [8, 20, 32, 44, 56, 68, 80, 92],
    [9, 21, 33, 45, 57, 69, 81, 93],
    [10, 22, 34, 46, 58, 70, 82, 94],
    [11, 23, 35, 47, 59, 71, 83, 95],
    [12, 24, 36, 48, 60, 72, 84, 96]
  ];

  const zodiacData = [
    ["2021-02-12", "2022-01-31", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau"],
    ["2022-02-01", "2023-01-21", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci"],
    ["2023-01-22", "2024-02-09", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga"],
    ["2024-02-10", "2025-01-29", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular"],
    ["2025-01-29", "2026-02-16", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda"],
    ["2026-02-16", "2027-02-05", "Kuda", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing"],
    ["2027-02-05", "2028-01-25", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet"],
    ["2028-01-25", "2029-02-12", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam"],
    ["2029-02-12", "2030-02-02", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing"],
    ["2030-02-02", "2031-01-22", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi"],
    ["2031-01-22", "2032-02-10", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau", "Tikus"],
    ["2032-02-10", "2033-01-30", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau", "Kerbau"],
    ["2033-01-30", "2034-02-18", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci", "Harimau"],
    ["2034-02-18", "2035-02-07", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga", "Kelinci"],
    ["2035-02-07", "2036-01-27", "Kelinci", "Harimau", "Kerbau", "Tikus", "Babi", "Anjing", "Ayam", "Monyet", "Kambing", "Kuda", "Ular", "Naga"]
  ];

  
  const getShioAnimal = (number, dateStr) => {
    const lastTwoDigits = parseInt(number.slice(-2));

    let positionIndex = -1;
    constantData.forEach((group, index) => {
      if (group.includes(lastTwoDigits)) {
        positionIndex = index;
      }
    });

    if (positionIndex === -1) return "N/A";

    const date = new Date(dateStr);
    let animalName = "N/A";
    zodiacData.forEach(([start, end, ...animals]) => {
      const startDate = new Date(start);
      const endDate = new Date(end);      
      if (date >= startDate && date <= endDate) {
        animalName = animals[positionIndex];
      }
    });

    const displayIndex = positionIndex + 1;
    return animalName;
  };

  const handleResetPageNo = () => {
    setResetPage(false);
  };

    const getTranslatedDay = (day) => {
      switch (day.toLowerCase()) {
        case "monday":
          return props.t('monday');
        case "tuesday":
          return props.t('tuesday');
        case "wednesday":
          return props.t('wednesday');
        case "thursday":
          return props.t('thursday');
        case "friday":
          return props.t('friday');
        case "saturday":
          return props.t('saturday');
        case "sunday":
          return props.t('sunday');
        default:
          return day;
      }
    };  

  return (
    <>
      <div>
        <div className="data-analysis">
          <div className="cate-heading">
            <h2>{country_name} {props.t('number')} Data {props.t('analysis')}</h2>
          </div>
          <div className="container data-table">
            <table>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>{props.t('day')}</th>
                  <th>{props.t('date')}</th>
                  <th>{props.t('result')}</th>
                  <th>Shio</th>
                </tr>
              </thead>
              <tbody>
                {last10Result.length > 0 ? (
                  last10Result.map((result, index) => {
                    const date = new Date(result.datetime);
                    const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                    const shioAnimal = getShioAnimal(result.number, result.datetime);
                    const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
                    const translatedDay = getTranslatedDay(dayName);

                    return (
                      <tr
                        key={result.period}
                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        {/* <td>
                          {date.toLocaleDateString("en-US", { weekday: "long" })}
                        </td> */}
                        <td>{translatedDay}</td>
                        <td>{formattedDate}</td>
                        <td>{result.number}</td>
                        <td>{shioAnimal}</td>

                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="4">No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
            <PaginationResult resetPage={resetPage} handleResetPageNo={handleResetPageNo} />
          </div>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(ShioResult);

